import { Card } from '@consigli/shadcn';

import { type Tile } from './tiles';

interface TileGroupProps {
  title: string;
  tiles: Tile[];
}

export const TileGroup = ({ title, tiles }: TileGroupProps) => (
  <section aria-label={title} className="flex flex-col gap-2">
    <h3 className="text-xs font-semibold uppercase tracking-wide text-muted-foreground">{title}</h3>
    <div className="grid grid-cols-2 gap-3 md:grid-cols-3 xl:grid-cols-5">
      {tiles.map((tile) => (
        <Card key={tile.label} className="gap-1 px-4 py-3 shadow-none">
          <span className="truncate text-sm text-muted-foreground">{tile.label}</span>
          <div className="flex flex-wrap items-baseline gap-x-2">
            <span className="text-2xl font-semibold">{tile.value}</span>
            {tile.unit && <span className="text-sm text-muted-foreground">{tile.unit}</span>}
          </div>
          {tile.note && <span className="text-xs text-muted-foreground">{tile.note}</span>}
        </Card>
      ))}
    </div>
  </section>
);
